import Text from "@ingka/text";
import SSRIcon from "@ingka/ssr-icon";
import greenCheckmark from "@ingka/ssr-icon/paths/checkmark-green-small";
import { formatDateTime } from "@/utils/misc";

export type CommentProps = {
  userName: string;
  isMine: boolean;
  createdAt: string;
  message: string;
  seen: boolean;
};

export const Comment = ({
  userName,
  isMine,
  createdAt,
  message,
  seen,
}: CommentProps) => {
  return (
    <section className="flex justify-end">
      <div className={`space-y-space50 ${isMine ? "" : "w-full"}`}>
        <div
          className={`mt-[5px] space-x-space50 ${
            isMine ? "flex justify-end" : "flex justify-start"
          }`}
        >
          <Text tagName="span" bodySize="s">
            {userName}
          </Text>
          <Text tagName="span" bodySize="s">
            {formatDateTime(createdAt)}
          </Text>
          {isMine && seen && (
            <SSRIcon
              // TODO: NEEDS ALT FOR a11y
              data-testid="seen-icon"
              paths={greenCheckmark}
              className="h-[20px] w-[20px]"
            />
          )}
        </div>
        <div className="inline-block min-h-[75px] min-w-[300px] max-w-[500px] bg-[#F5F5F5] p-space50">
          <Text
            tagName="p"
            bodySize="m"
            className="whitespace-pre-wrap text-left"
          >
            {message}
          </Text>
        </div>
      </div>
    </section>
  );
};
